import { Breadcrumbs } from './Breadcrumbs';
import { Breadcrumb } from './Breadcrumb';

Breadcrumbs.Breadcrumb = Breadcrumb;

export { Breadcrumbs } from './Breadcrumbs';
